import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { uniqueId } from 'lodash';

import Tooltip from 'components/Tooltip';

import { FiEye } from 'react-icons/fi';

import WidgetLoader from 'components/ContentLoader/WidgetLoader';

import { Container, Body, Icon, Footer, Link, Count } from './styles';

export default function Widget({
  color = 'default',
  type = 'normal',
  loading = false,
  showLink = true,
  inverted = false,
  active = false,
  title,
  to,
  icon,
  data,
  handleClick,
}) {
  const [id] = useState(`id_widget_${uniqueId(new Date().getTime())}`);

  return (
    <>
      <Container id={id} type={type} $active={active} onClick={handleClick}>
        {!loading && (
          <>
            <Body $inverted={inverted}>
              <Icon $inverted={inverted} type={type} color={color}>
                {icon}
              </Icon>

              <div>
                {type !== 'mini' && <p>{title}</p>}
                <strong>
                  {Array.isArray(data) ? (
                    <>
                      <Count
                        delay={0.5}
                        duration={4}
                        start={0}
                        end={data[0]}
                        preserveValue
                      />
                      {data[1] !== null && (
                        <>
                          <span>/</span>
                          <Count
                            delay={0.5}
                            duration={4}
                            start={0}
                            end={data[1]}
                            preserveValue
                          />
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      <Count
                        delay={0.5}
                        duration={4}
                        start={0}
                        end={data}
                        redraw={false}
                        preserveValue
                      />
                    </>
                  )}
                </strong>
                {data[2] ? (
                  <>
                    <p>Arquivados: {data[2]}</p>
                  </>
                ) : (
                  <p />
                )}
              </div>
            </Body>
            {showLink && type === 'normal' && (
              <>
                <hr />
                <Footer>
                  <FiEye />
                  <Link to={to || '#'} onClick={handleClick}>
                    Visualizar
                  </Link>
                </Footer>
              </>
            )}
          </>
        )}
        {loading && <WidgetLoader />}
      </Container>

      {type === 'mini' && (
        <Tooltip position="right" target={id}>
          {title}
        </Tooltip>
      )}
    </>
  );
}

// Widget.defaultProps = {
//   color: 'default',
//   type: 'normal',
//   loading: false,
//   showLink: true,
//   inverted: false,
//   active: false,
// };

Widget.propTypes = {
  type: PropTypes.oneOf(['normal', 'condensed', 'mini']),
  title: PropTypes.string,
  color: PropTypes.string,
  to: PropTypes.string,
  active: PropTypes.bool,
  loading: PropTypes.bool,
  inverted: PropTypes.bool,
  showLink: PropTypes.bool,
  handleClick: PropTypes.func,
};
